import * as React from 'react'
import useCart from 'hooks/account/cart/useCart'

type Context = {
  deletedItems: string[]
  setDeletedItems: (items: string[]) => void
  deleteItem: (item: string) => void
  deletedItem: string
  cartUpdating: boolean
}

const Context = React.createContext<Context>({
  deletedItems: [],
  setDeletedItems: () => {},
  deleteItem: () => {},
  deletedItem: '',
  cartUpdating: false
})

export default function useCartDeleteContex() {
  return React.useContext(Context)
}
export function CartDeleteContextProvider(props: {
  children: React.ReactElement
}) {
  const [deletedItems, setDeletedItems] = React.useState<string[]>([])
  const [deletedItem, setDeletedItem] = React.useState<string>('')

  const cart = useCart()

  React.useEffect(() => {
    if (!cart.updating) {
      const item = deletedItems.pop()
      if (item) {
        cart.removeItem(item)
        setDeletedItem(item)
        setDeletedItems((prev) => prev.filter((i) => i !== item))
      }
    }
  }, [cart.updating])

  const value = {
    deletedItems,
    setDeletedItems,
    deleteItem: (item: string) => {
      if (cart.updating) {
        setDeletedItems((prev) => [...prev, item])
      } else {
        cart.removeItem(item)
        setDeletedItem(item)
        setDeletedItems((prev) => prev.filter((i) => i !== item))
      }
    },
    deletedItem: deletedItem,
    cartUpdating: cart.updating
  }

  return <Context.Provider value={value}>{props.children}</Context.Provider>
}
